import React, {useState, useEffect, useCallback, useRef} from 'react'
import axios from 'axios'
import { Drawer, Typography  } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import {Link} from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate,faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from "react-redux";

import { PageTitle } from "../../../../_template/layout/core/PageData";
// =================== component import ==================== //
import NoDataFound from '../../../component/common/NoDataFound';
import Pagination from '../../../component/common/pagination/Pagination';
import BotList from './component/BotList';
import BotDetails from './component/BotDetails';
import BotListSkeleton from './component/BotListSkeleton';

const { Title, Text } = Typography;
const Agents = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    const assignPermission = useSelector((state) => state.store_permission_data.permissionArr);
    const botSetupHomeTitle = [
        {
            title: loginUserType === 'A' ? 'Agents' : loginUserType === 'SA' ? 'Agent' : 'Agents',
            path: loginUserType === 'A' ? '/agents' : loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];
    const navigate = useNavigate();

    // ===================================== define all state ============================= //
    const [botSearchValue, setBotSearchValue] = useState('');
    const [paginationData, setPaginationData] = useState({});
    const [ botUpdateId , setBotUpdateId] = useState('');
    const [page, setPage] = useState(1);
    const [ botList, setBotList ] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [botIdState, setBotIdState] = useState('');
    const [ botNameState, setBotNameState ] = useState('');
    const [ totBotDetails, setTotBotDetails ] = useState({});
    const [isSearchButtonLoder, setIsSearchButtonLoder] = useState(false);
    const [ viewLogDrawerOpen, setViewLogDrawerOpen ] = useState(false);
    const [logPage, setLogPage] = useState(1);
    const [isLoader, setIsLoader] = useState(true);
    const [sideDrawerLoader, setSideDrawerLoader] = useState(true);
    // ================================================================================== //
    const botSearchOnChange = (eve) => {
        setBotSearchValue(eve.target.value);
    }
    // -------------- get bot list -------------- //
    const dataLimit = 50;
    const getBotList = async () => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'D') {
            apiToken = localStorage.getItem('developertoken')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        var data = {
            searchData: botSearchValue,
            page : page,
            limit : dataLimit,
            bot_update_id: botUpdateId,
            page:page,
            sass_id: localStorage.getItem('sass_id')
        }
        await axios.post(`${api_base_url}admin/get-bot-list`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                if(botUpdateId === ''){
                    setBotList(res.data.data.bot_data);
                    setPaginationData({
                        current_pages : res.data.data.current_pages,
                        total_data_count : res.data.data.total_count,
                        total_pages : res.data.data.total_pages,
                        limit : res.data.data.limit,
                        data_length : res.data.data.bot_data.length
                    })
                    setIsSearchButtonLoder(false)
                }
                else{
                    var botUpdateData = res.data.data.bot_data[0];
                    // props.agentUpdateData(agentUpdateData)
                    setBotUpdateId('')
                }
                setIsLoader(false)
            } else if(res.data.status === 'error') {
                console.error('error')
                setIsLoader(false)
            }
        })
        .catch((error) => {
            console.error(error);
            setIsLoader(false)
        })
    }
    const getBotOthersDetails = async () => {
        if(!botIdState) return;
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        const reqData = {
            bot_id : botIdState,
            sass_id : localStorage.getItem('sass_id')
        }
        await axios.post(`${api_base_url}admin/get-bot-details`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                var resData = res.data.data.bot_details[0];
                setTotBotDetails(resData)
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    const drawerIsOpenHandler = (param) => {
        if (param && param.bot_id) {
            setBotIdState(param.bot_id);
        }
        else{
            setBotIdState('');
        }
        if (param && param.bot_name) {
            setBotNameState(param.bot_name);
        }
        else{
            setBotNameState('');
        }
        if(param.type === 'open'){
            setDrawerOpen(true)
        }
        else if(param.type === 'close'){
            setDrawerOpen(false)
        }
    }
    // --------- bot update section --------- //
    const botUpdateOnClickHandler = (bot_id) => {
        localStorage.setItem('currentStep', 1);
        const routes = {
            'A': "/manage-virtual-agent",
            'D': "/virtual-agent",
            'SA': "manage-virtual-agent"
        };
        if (routes[loginUserType]) {
            console.log(`${routes[loginUserType]}/${bot_id}`)
            navigate(`${routes[loginUserType]}/${bot_id}`);
        }
    }
    // ------- bot delete handler -------- //
    const botDeleteOnClickHandler = async(bot_id) => {
        await Swal.fire({
            text: 'Are you sure to delete this record ?',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton : true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK, Delete',
        }).then(async (result) => {
            if (result.isConfirmed) {
                if(!bot_id) return;
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                const apiHeaders = {
                    headers: {
                        "x-access-token": apiToken,
                    },
                };
                let reqObj = {
                    bot_id: bot_id,
                    sass_id : localStorage.getItem('sass_id'),
                    user_type : localStorage.getItem('type'),
                    user_name : loginUserType == 'SA' ? localStorage.getItem('system_username') : ''
                }
                try {
                    await axios.post(`${api_base_url}admin/delete-bot-data`, reqObj, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            toast.success(res.data.message);
                            getBotList()
                        }
                        else if(res.data.status === 'error'){
                            toast.error(res.data.message);
                        }
                        else{
                            toast.error("There is an error");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
        })
    }
    const botStatusUpdateOnChangeHandler = async (bot_id, e) => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const apiHeaders = {
            headers: {
                "x-access-token": apiToken,
            },
        };
        let reqObj = {
            bot_id: bot_id,
            active_status : e,
            sass_id : localStorage.getItem('sass_id'),
            user_type : localStorage.getItem('type'),
            user_name : loginUserType == 'SA' ? localStorage.getItem('system_username') : ''
        }
        try {
            await axios.post(`${api_base_url}admin/change-bot-active-status`, reqObj, apiHeaders)
            .then(async (res) => {
                if(res.data.status === 'success'){
                    toast.success(res.data.message);
                    getBotList()
                }
                else if(res.data.status === 'error'){
                    toast.error(res.data.message);
                }
                else{
                    toast.error("There is an error");
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error) {
            console.error("Error during save:", error);
        }
    }

    const containerRef = useRef(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);


    const loadMore = async () => {
        if (loading || done) return;
        setLoading(true);
        try {
            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            var api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            var data = {
                bot_id: botIdState,
                page: logPage,
                sass_id: localStorage.getItem('sass_id'),
            }
            await axios.post(`${api_base_url}admin/get-others-log-details`, data, api_headers)
            .then(async (res) => {
                setSideDrawerLoader(false)
                if(res.data.status === 'success') {
                    var data = res.data.data;
                    if (!data || data.trim() === '') {
                        setDone(true);
                    } else {
                        setLogs(prevLogs => [...prevLogs, data]);
                        setLogPage(prevPage => prevPage + 1);
                    };
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
                setSideDrawerLoader(false)
            })
        } catch (error) {
            setDone(true);
        } finally {
            setLoading(false);
        }
    };

    const getLogFunc = async () => {
        if (loading || done) return;
        setLoading(true);
        try {
            var api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('systemAdminToken')
                }
            };
            var data = {
                bot_id: botIdState,
                page: logPage,
                sass_id: localStorage.getItem('sass_id'),
            }
            await axios.post(`${api_base_url}admin/get-bot-log`, data, api_headers)
            .then(async (res) => {
                setSideDrawerLoader(false)
                if(res.data.status === 'success') {
                    var data = res.data.data;
                    if (!data || data.trim() === '') {
                        setDone(true);
                    } else {
                        setLogs(prevLogs => [...prevLogs, data]);
                        setLogPage(prevPage => prevPage + 1);
                    };
                    
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
                setSideDrawerLoader(false)
            })
        } catch (error) {
            setDone(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(!viewLogDrawerOpen){
            setDone(false)
            setLogs([])
            setLogPage(1)
            setSideDrawerLoader(true)
            return
        }
        // loadMore();
        loginUserType == "SA" ? getLogFunc() : loadMore();
    }, [viewLogDrawerOpen]);

    const handleScroll = () => {
        const el = containerRef.current;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            // loadMore();
            loginUserType == "SA" ? getLogFunc() : loadMore();
        }
    };

    const downloadCsvOnClickHandler = async (botId) => {
        var apiToken = localStorage.getItem('systemAdminToken');
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        var data = {
            bot_id: botId,
        };
        await axios.post(`${api_base_url}api/download-bot-details-csv`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const csvFileName = res.data.data.file_name;
                const csvFilePath = res.data.data.file_path;
                const filePath = `${api_base_url}api/any-file-download?file_path=${csvFilePath}&file_name=${csvFileName}&file_is_delete=yes`;
                window.location.href = filePath;
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const viewLogOnClickHandler = (botId) => {
        setBotIdState(botId)
        setViewLogDrawerOpen(true)
    }

    useEffect(() => {
        getBotOthersDetails()
    },[drawerOpen]);

    useEffect(() => {
        getBotList();
    },[page]);
    let botListHtml = (
        <NoDataFound className="w-30" setHtml="No data found" />
    );
    if(botList.length > 0){
        botListHtml = botList.map((botData) => 
            <BotList
                key={botData.bot_id}
                sass_id={botData.sass_id}
                bot_id={botData.bot_id}
                bot_name={botData.bot_name}
                channel_name={botData.channel_name}
                language={botData.language}
                bot_status={botData.bot_status}
                bot_avtar={botData.bot_avtar}
                active_status={botData.active_status}
                bot_hook_type={botData.bot_hook_type}
                bot_hook={botData.bot_hook}
                widget_id={botData.widget_id}
                updated_at={botData.updated_at}
                bot_status_error_msg={botData.bot_status_error_msg}
                bot_description={botData.bot_description}
                drawerIsOpen={drawerIsOpenHandler}
                botUpdateOnClick={botUpdateOnClickHandler}
                botDeleteOnClick={botDeleteOnClickHandler}
                botStatusUpdateOnChange={botStatusUpdateOnChangeHandler}
                downloadCsvOnClick={downloadCsvOnClickHandler}
                viewLogOnClick={viewLogOnClickHandler}
            />
        )
    }
    // ------- pagination ----- //
    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }
    const botSearchOnClick = () => {
        setIsSearchButtonLoder(true)
        getBotList()
    }

    const hasData = botList.length > 0;
    const noData = !isLoader && !hasData;

    const hasLogData = logs.length > 0;
    const noLogData = !sideDrawerLoader && !hasLogData;

    return (
        <>
            <PageTitle breadcrumbs={botSetupHomeTitle}>Agents</PageTitle>
            <div className="row">
                <div className='col-md-12'>
                    <div className='card card-rounded border'>
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark">
                                    Agent
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {paginationData.data_length ? paginationData.data_length : 0} agents are available
                                </span>
                            </h3>
                            <div className="card-toolbar">
                                <div className="d-flex flex-stack flex-wrap gap-0">
                                    <div className="position-relative me-2 m-w-100">
                                        {/* <input type="text" className="form-control w-350px" placeholder="Search by agent name or id" value={botSearchValue} onChange={botSearchOnChange} /> */}
                                        <div className="input-group">
                                            <input type="text" className="form-control w-350px" placeholder="Search by agent name or id" value={botSearchValue} onChange={botSearchOnChange} />
                                            <span 
                                                className="input-group-text cursor-pointer"
                                                onClick={botSearchOnClick}
                                                disabled={isSearchButtonLoder ? true : false}
                                            >
                                                {
                                                    isSearchButtonLoder ?
                                                    <FontAwesomeIcon icon={faArrowsRotate} className='fs-3 fa-spin'/> 
                                                :
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                }
                                            </span>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center fw-bold">
                                        {/* <button 
                                            className='btn btn-light-primary px-6 btn-icon me-2' 
                                            onClick={botSearchOnClick}
                                            disabled={isSearchButtonLoder ? true : false}
                                        >
                                            {
                                                isSearchButtonLoder ?
                                                <FontAwesomeIcon icon={faArrowsRotate} className='fs-3 fa-spin'/> 
                                                :
                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                            }
                                        </button> */}
                                        {
                                            loginUserType != 'SA' && assignPermission.allow_add_new === 'Y' &&
                                            <Link
                                                className={`btn btn-warning px-6`}
                                                to={loginUserType === 'A' ? '/manage-virtual-agent' : loginUserType === 'SA' ? 'manage-virtual-agent' : '/virtual-agent'}
                                            >
                                                Create Agent
                                            </Link>
                                        }
                                        {
                                            loginUserType === 'SA' &&
                                            <Link
                                                className={`btn btn-warning px-6`}
                                                to='manage-virtual-agent'
                                            >
                                                Create Agent
                                            </Link>
                                        } 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row mt-3'>
                <div className='col-md-12'>
                    <div className="card card-flush h-md-100 border">
                        <div className="card-body pt-6">
                            {
                                isLoader &&
                                <BotListSkeleton rows={10}/>
                            }
                            {
                                hasData && 
                                <div className="table-responsive">
                                    <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                                        <thead>
                                            <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                                <th className="" style={{minWidth: '250px'}}>
                                                    Name
                                                </th>
                                                <th className="">
                                                   Description
                                                </th>
                                                <th className="" style={{minWidth: '100px'}}>
                                                    Status
                                                </th>
                                                <th className="" style={{minWidth: '100px'}}>
                                                    Channel
                                                </th>
                                                <th className="" style={{minWidth: '100px'}}>
                                                    Language
                                                </th>
                                                <th className="" style={{minWidth: '130px'}}>
                                                   Last Updated On
                                                </th>
                                                
                                                <th className="">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {botListHtml}
                                        </tbody>
                                    </table>
                                </div>
                            }
                            {
                                noData &&
                                <NoDataFound
                                    setHtml="Data Not Found"
                                    className="w-30"
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
            {hasData > 0 && 
                <Pagination
                    pagination_data={paginationData}
                    onClick={pagechangeHandler}
                />
            } 
            {/* ========== bot details drawer ======= */}
            <Drawer
                title={
                    <div>
                        <Title className='mb-0 fs-3 text-gray-800'>{botNameState} Details</Title>
                        <Text className='text-gray-400'>{botIdState}</Text>
                    </div>
                }
                width={1000}
                open={drawerOpen}
                placement={'right'}
                closable={false}
                extra={
                    <a className="btn btn-sm btn-dark me-3 px-4" onClick={() => drawerIsOpenHandler({type:'close'})}>
                        Close
                    </a>
                }
                styles={{ body: { overflowX: "hidden" } }}
            >
                <BotDetails
                    bot_id= {botIdState}
                    bot_details={totBotDetails}
                />
            </Drawer>
            {/* =========== view log drawer ========= */}
            <Drawer
                title={
                    <div>
                        <Title className='mb-0 fs-3 text-gray-800'>Log Details</Title>
                        <Text className='text-gray-400'>{botIdState}</Text>
                    </div>
                }
                width={1200}
                open={viewLogDrawerOpen}
                placement={'right'}
                closable={false}
                extra={
                    <a className="btn btn-sm btn-dark me-3 px-4"
                        onClick={() => {
                            setViewLogDrawerOpen(false);
                            setBotIdState('');
                        }}
                    >
                        Close
                    </a>
                }
                styles={{ body: { overflowX: "hidden" } }}
            >
                <div
                    id="logContainer"
                    ref={containerRef}
                    onScroll={handleScroll}
                    style={{
                        height: '100%',
                        overflowY: 'scroll',
                        background: '#f5f5f5',
                        padding: '10px',
                        border: '1px solid #ccc'
                    }}
                >
                    {
                        sideDrawerLoader &&
                        <div className='row text-center'>
                            <div className='col-md-12'>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        noLogData &&
                        <div className='row text-center'>
                            <div className='col-md-12'>
                                No logs found
                            </div>
                        </div>
                    }
                    {
                        hasLogData && 
                        logs.map((log, index) => (
                            <pre key={index}>{log}</pre>
                        ))
                    }
                </div>
            </Drawer>
        </>
    )
}

export default Agents